import dayjs from "dayjs";
import type { TableColumnType, TableColumnsType } from "ant-design-vue";

const promiseDataColumns = (date: string, width?: number): TableColumnType[] => {
  const count: TableColumnType = {
    title: "Cantidad",
    dataIndex: [date, "total_pdp"],
    customRender: ({ text }) => text ?? 0,
  };

  const amount: TableColumnType = {
    title: "Monto de PDP",
    dataIndex: [date, "total_amount"],
    customRender: ({ text }) => text ?? 0,
  };

  if (width) {
    count.width = width;
    amount.width = width;
    count.minWidth = width;
    amount.minWidth = width;
  }

  return [count, amount];
};

export function getDayColumns(startDate: string, endDate: string): TableColumnsType {
  const start_date = dayjs(startDate);
  const end_date = dayjs(endDate);
  const dayColumns: TableColumnsType = [];

  const daysDiff = end_date.diff(start_date, "day");

  for (let addDays = 0; addDays <= daysDiff; addDays++) {
    const date = start_date.add(addDays, "day");

    const day = {
      title: date.format("DD/MM/YYYY"),
      dataIndex: date.format("YYYY-MM-DD"),
      key: date.format("YYYY-MM-DD"),
      children: promiseDataColumns(date.format("YYYY-MM-DD"), 120),
    };

    dayColumns.push(day);
  }

  dayColumns.push({
    title: "Total",
    dataIndex: "Total",
    key: "Total",
    children: promiseDataColumns("Total", 120).map((column) => ({ ...column, fixed: "right" })),
    fixed: "right",
  });

  return dayColumns;
}

export function getRankingColumns(startDate: string, endDate: string): TableColumnsType {
  const columns: TableColumnsType = [
    { title: "Usuario", dataIndex: ["user", "fullname"], key: "user", width: 200, ellipsis: true },
    ...getDayColumns(startDate, endDate),
  ];

  return columns;
}
